<app-report-selection *ngIf="registrations != null" [registrations]="registrations"></app-report-selection>
